import { toggleClass } from "../helper/class-toggle";

const brokerCardToggle = () => {
  toggleClass("js-broker-card-toggle", "remaining-pop", "is-close");
};

const brokerCardInit = () => {
  brokerCardToggle();
};

document.addEventListener("DOMContentLoaded", function () {
  brokerCardInit();
});
